import React, { useContext, useState } from 'react';
import { WIconButton, WMenu, WMenuItem, WStack, WTypography } from '../../wrappers/wrapper';
import styles from './article-card.module.scss';
import { TArticle, TUser } from '../../../models/common';
import { MoreHorizRounded, Favorite, FavoriteBorder, ChatBubbleOutline } from '@mui/icons-material';
import ViewProfile from '../../prefabs/view-profile-popover/view-profile-popover';
import { ARTICLE_DEFAULT_IMAGE } from '../../../utils/constants';
import moment from 'moment';
import ProfilePhoto from 'components/molecules/profile-photo/profile-photo';
import { UserContext } from 'contexts/userContext';

interface ArticleCardProps {
  data: TArticle;
  anchorEl: HTMLElement | null;
  open: boolean;
  isLiked: boolean;
  totalLikeCount: number;
  totalCommentCount: number;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleClose: () => void;
  navigateToArticle: (article_id: string) => void;
  onLikeClick?: () => void;
  deleteArticle: (article_id: string) => any;
  hideInteractions?: boolean;
}

const ArticleCard: React.FC<ArticleCardProps> = ({
  data,
  anchorEl,
  isLiked,
  totalLikeCount,
  totalCommentCount,
  handleClick,
  open,
  handleClose,
  navigateToArticle,
  onLikeClick,
  deleteArticle,
  hideInteractions,
}) => {
  const { user } = useContext(UserContext);
  const [profileUserId, setProfileUserId] = useState('');
  const [isProfileBoxVisible, setIsProfileBoxVisible] = useState(false);
  const isOwner = user?._id === (data.publisher as TUser)._id;

  return (
    <WStack className={styles['card-container']}>
      <div className={styles.top}>
        <img
          onClick={() => navigateToArticle(data._id!)}
          src={data.cover_image || ARTICLE_DEFAULT_IMAGE}
          alt={data.title}
          className={styles['card-cover-image']}
        />
        {!hideInteractions && (
          <WStack className={styles['card-content']}>
            <ProfilePhoto
              onClick={() => {
                setProfileUserId((data.publisher as TUser)._id!);
                setIsProfileBoxVisible(true);
              }}
              radius="100%"
              user={data.publisher}
              fontSize="1rem"
            />
            <WStack className={styles['card-labels']} onClick={() => navigateToArticle(data._id!)}>
              <span className={styles['card-title']}>{data.title}</span>
              <p className={styles['card-post-time']}>
                {(data.publisher as TUser).username} posted {moment(data.created_at).fromNow()}
              </p>
            </WStack>
          </WStack>
        )}
        {hideInteractions && (
          <WStack className={styles['card-content']}>
            <WStack className={styles['card-labels']} onClick={() => navigateToArticle(data._id!)}>
              <span className={styles['card-title']}>{data.title}</span>
            </WStack>
          </WStack>
        )}
      </div>
      {!hideInteractions && (
        <div className={styles.bottom}>
          <div className={styles.actions}>
            <div onClick={onLikeClick}>
              {isLiked ? <Favorite fontSize="small" /> : <FavoriteBorder fontSize="small" />}
              <span>{totalLikeCount}</span>
            </div>
            <div onClick={() => navigateToArticle(data._id!)}>
              <ChatBubbleOutline fontSize="small" />
              <span>{totalCommentCount}</span>
            </div>
          </div>
        </div>
      )}
      {isProfileBoxVisible && !hideInteractions && (
        <ViewProfile
          showEditButton={false}
          user_id={profileUserId}
          onClose={() => setIsProfileBoxVisible(false)}
        />
      )}
      {isOwner && !hideInteractions && (
        <WIconButton className={styles['card-more-icon']} onClick={handleClick}>
          <MoreHorizRounded fontSize="small" />
        </WIconButton>
      )}
      <WMenu id="more-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
        <WMenuItem
          onClick={() => {
            handleClose();
            deleteArticle(data._id!);
          }}
        >
          <WTypography color="red">Delete</WTypography>
        </WMenuItem>
      </WMenu>
    </WStack>
  );
};

export default ArticleCard;
